/**
 * Returns onColor object
 *
 * @param theme - Theme object
 * @param onColor - Color of background on which is located styling element
 * @returns onColor object
 */
var getOnColor = function getOnColor(theme, onColor) {
  var _theme$colors$onColor;
  return (_theme$colors$onColor = theme.colors[onColor]) === null || _theme$colors$onColor === void 0 ? void 0 : _theme$colors$onColor.onColor;
};
export default getOnColor;